<template>
  <div v-tippy :title="noTooltip ? '' : sourceTitle" class="support-desk-icon">
    <img
      v-if="sourceImage"
      :src="iconPath"
      :alt="sourceTitle"
      :class="large ? 'icon-l' : small ? 'icon-s' : 'icon-m'"
    />
    <span v-else>🔌</span>
  </div>
</template>

<script setup lang="ts">
import { defineComponent, computed } from 'vue'
import { capitalize } from 'lodash-es'

import i18n from '@/i18n'
import config from '@/config'

const props = defineProps<{
  source?: string
  noTooltip?: boolean
  grayscale?: boolean
  small?: boolean
  large?: boolean
}>()

defineComponent({ name: 'SupportDeskIcon' })

const images = {
  aircall: 'aircall.svg',
  aircallMono: 'aircall_mono.svg',
  browserextension: 'browser_extension_mono.svg',
  browserextensionMono: 'browser_extension_mono.svg',
  dixa: 'dixa.svg',
  dixaMono: 'dixa_mono.svg',
  freshchat: 'freshchat.svg',
  freshchatMono: 'freshchat_mono.svg',
  front: 'front.svg',
  frontMono: 'front_mono.svg',
  freshdesk: 'freshdesk.svg',
  freshdeskMono: 'freshdesk_mono.svg',
  genesys: 'genesys.svg',
  genesysMono: 'genesys_mono.svg',
  gorgias: 'gorgias.svg',
  gorgiasMono: 'gorgias_mono.svg',
  helpscout: 'helpscout.svg',
  helpscoutMono: 'helpscout_mono.svg',
  helpshift: 'helpshift.svg',
  helpshiftMono: 'helpshift_mono.svg',
  intercom: 'intercom.svg',
  intercomMono: 'intercom_mono.svg',
  kustomer: 'kustomer.svg',
  kustomerMono: 'kustomer_mono.svg',
  livechat: 'livechat.svg',
  livechatMono: 'livechat_mono.svg',
  manualimport: 'manual_import_mono.svg',
  manualimportMono: 'manual_import_mono.svg',
  salesforce: 'salesforce.svg',
  salesforceMono: 'salesforce_mono.svg',
  talkdesk: 'talkdesk.svg',
  talkdeskMono: 'talkdesk_mono.svg',
  zendesk: 'zendesk.svg',
  zendeskMono: 'zendesk_mono.svg',
  zendeskchat: 'zendesk_chat.svg',
  zendeskchatMono: 'zendesk_chat_mono.svg',
}

const sourceImage = computed(() => {
  let key = props.source?.toLowerCase().replace(/_/g, '')

  if (props.grayscale) key += 'Mono'

  return images[key] || null
})

const iconPath = computed(() => `${config.assetsUrl}img/helpdesk/${sourceImage.value}`)

const sourceTitle = computed(() => {
  let formattedSource = capitalize(props.source?.replace(/_/g, ' '))

  if (props.source === 'MANUAL_IMPORT') formattedSource = i18n.t('components.helpdesk_icon.manual_import')

  return i18n.t('components.helpdesk_icon.generic_source', [formattedSource])
})
</script>

<style>
.support-desk-icon {
  display: flex;
  align-items: center;
}
</style>
